import React, { FC } from 'react';
import { List, Link } from '@printdeal/ui-library';

interface FooterLinkProps {
  title?: string;
  url?: string;
  openInNewTab?: boolean;
  path?: string;
  className?: string;
  onClick?: (title: string) => unknown;
}

export const FooterLink: FC<FooterLinkProps> = ({
  url, path, title, openInNewTab, className, onClick,
}) => {
  if (!title) return null;

  const handleOnClick = typeof onClick === 'function' ? onClick : () => {};

  return (
    <List.Item
      key={title}
      className={className}
      data-cy="footer-li-select"
    >
      {path && (
        <Link
          variant="secondary"
          href={path}
          onClick={() => handleOnClick(title)}
          data-testid="footer-link-path"
        >
          {title}
        </Link>
      )}
      {url && !path && openInNewTab && (
        <Link
          variant="secondary"
          href={url}
          target="_blank"
          onClick={() => handleOnClick(title)}
          rel="noreferrer"
          data-testid="footer-link-ext-blank"
        >
          {title}
        </Link>
      )}
      {url && !path && !openInNewTab && (
        <Link
          variant="secondary"
          href={url}
          onClick={() => handleOnClick(title)}
          data-testid="footer-link-ext"
        >
          {title}
        </Link>
      )}
      {!url && !path && (
        <span data-testid="footer-text">{title}</span>
      )}
    </List.Item>
  );
};
